module.exports = __webpack_public_path__ + "img/paper_negative.ce75ae15.svg";